const version = 'Версия 23.10.01';

export {
    version
}
